// グローバル変数
var _movement_map_settings_ = false;    // PHPのconf、langなどのstatic設定取り込み用
var _movement_map_data_     = false;    // 取得したmap_data退避用
var _movement_settings_     = false;    // 取得したmovement_settings退避用
var _tracking_id_           = false;

var _refresh_timer_         = false;
var _refresh_interval_      = 60000;     // [msec]

var _is_filter_mode_1_      = false;
var _is_filter_mode_2_      = false;
var _is_filter_mode_3_      = false;

const TRACKING_VEHICLE_ICON = '/assets/img/movement/vehicles/icon_tracking_vehicle.png';

/**
 * 免許証認証アイコン定義
 *  key1 :免許証認証ステータス(license_certification_status)  [1:認証OK、2:NG、3:手入力]
 *  value:アイコンイメージパス
 */
const LICENSE_CERTIFICATION_ICONS = {
    '2': '/assets/img/movement/license_certifications/icon_license_certification_ng.png',      // 2:NG
    '1': '/assets/img/movement/license_certifications/icon_license_certification_ok_blu.png',
    '4': '/assets/img/movement/license_certifications/icon_license_certification_ok_org.png',
    '5': '/assets/img/movement/license_certifications/icon_license_certification_ok_org.png',
    '6': '/assets/img/movement/license_certifications/icon_license_certification_ok_red.png',

    '3': '/assets/img/movement/license_certifications/icon_license_certification_ng_blu.png',
    '7': '/assets/img/movement/license_certifications/icon_license_certification_ng_org.png',
    '8': '/assets/img/movement/license_certifications/icon_license_certification_ng_org.png',
    '9': '/assets/img/movement/license_certifications/icon_license_certification_ng_red.png',
    '0': '/assets/img/movement/license_certifications/icon_license_certification_ng_red.png',
};

const LICENSE_CERTIFICATION_NAMES = {
    '2': '認証NG',      // 2:NG
    '1': '免許証認証（正常）',
    '4': '免許証認証（在職でない）',
    '5': '免許証認証（マスタ不備）',
    '6': '免許証読取不可',

    '3': 'ID認証（正常）',
    '7': 'ID認証（在職でない）',
    '8': 'ID認証（マスタ不備）',
    '9': 'ALL9入力',
    '0': '入力スキップ',
};

/**
 * 動態表示のイベント設定
 */
window.movement_map_event_set = function ()
{
    var _zMapMain = $('#map');
    var _zMapSub = $('#zmap_sub');

    // 地図要素が無い時は何もしない
    if (_zMapMain.length <= 0) {
        return;
    }

    // グローバル設定init
    _movement_map_settings_ = {
        url_get_movement_map_data: url_get_movement_map_data,
        url_temporary_return_list: url_temporary_return_list,
        url_save_request_behavior_data: url_save_request_behavior_data,
        url_save_request_video_data: url_save_request_video_data,
        url_setting_request_video : url_setting_request_video,
        url_set_default_map_position_data: url_set_default_map_position_data,
        url_temperature: url_temperature,
        messages: {
            /** 車両アイコン吹き出し表示用 */
            v_infobox:                  movement_base.v_infobox,
            /** 地点アイコン吹き出し表示用 */
            d_infobox:                  movement_base.d_infobox,
            /** 車両・乗務員リスト表示用設定 */
            info_list1:                  movement_config.movement_map.setting_data.options.info_list_settings1.options,
            /** 地点リスト表示用設定 */
            info_list2:                  movement_config.movement_map.setting_data.options.info_list_settings2.options,
            /** 免許証期限リスト表示用設定 */
            info_list3:                  movement_config.movement_map.setting_data.options.info_list_settings3.options,
            /** 地点区分(行先区分) */
            destination_types:          movement_base.destination_types,
            /** エリア区分 */
            destination_areas:          movement_base.destination_areas,
            /** 車両状態 */
            vehicle_status_types:       movement_base.vehicle_status_types,
            /** 実車／空車区分 */
            luggage_status_types:       movement_base.luggage_status_types,
            /** 免許証認証ステータス(1:認証OK、2:NG、3:手入力、null(または0):未認証) */
            license_certification_status_types: movement_base.license_certification_status_types,
            /** 免許証有効期限ステータス(>0:有効期限までの残日数、0:期限日、<0:期限切れ(経過日数)、null:期限日未設定) */
            license_limit_status_types: movement_base.license_limit_status_types,
            /** 情報表示エリア表示・非表示ボタン */
            right_area_show_button:      movement_map.right_area_show_button,
            right_area_hide_button:      movement_map.right_area_hide_button,
            /** 追尾中ラベル */
            tracking_label:             movement_map.tracking_label,
            /** 追尾中ラベル */
            tracking_reset_button:      movement_map.tracking_reset_button,
            /** 地図の中心位置・倍率設定・解除ボタン */
            map_position_fixed_button:  movement_map.map_position_fixed_button,
            map_position_reset_button:  movement_map.map_position_reset_button,
            /** (地点リスト)エリア欄オプション */
            // destination_area_options:   movement_map.search_area2.destination_area_options,
            /** マスタ未登録メッセージ */
            is_not_exists_master_message: movement_base.is_not_exists_master_message,
            alc_limit: movement_base.alc_limit,
            zipcode: movement_config.unit.zipcode,
            speed_unit: movement_config.unit.speed,
            alc_unit: movement_config.unit.alc,
        },
        others: {
            /** 追尾解除ボタンアイコン */
            img_icon_back: '/assets/img/movement/icon_back_1.png'
        },
    };
    /** 画面初期化処理 */
    movementInit();

    /**
     * 画面の初期化処理を行います。
     */
    function movementInit()
    {
        // --------------------------------
        // イベントセット
        // --------------------------------
        /**
         * 画面リサイズ時イベントの描画処理を行います。
         */
        $( window ).on('resize', function(){
            resizeDisplay();
        });

        /**
         * サイドバー切替ボタン押下時のイベント処理を行います
         */
        $(".sidebar-control").on('click', function(){
            setTimeout(function(){
                if (_zMapMain.mapMovement){
                    _zMapMain.mapMovement.resizeMap();
                }
                if (_zMapSub.mapMovementSub){
                    _zMapSub.mapMovementSub?.resizeMap();
                }
            }, 400);
        });

        /**
         * 画面終了時のイベント処理を行います。
         */
        $(window).on("beforeunload", function (e) {
            if (_movement_map_data_) {
                let is_tracking_mode    = _zMapMain.mapMovement.isTrackingMode();               // メイン地図が追尾モードかどうか？（１画面レイアウト時のみ）
                let is_fixed            = $('#map_position_is_fixed').val() || '';              // 地図デフォルト位置固定(0:無効、1:有効)
                if (is_fixed === '1' && !is_tracking_mode) {
                    /** 現在の地図の中心位置・倍率を取得 */
                    let params = _zMapMain.mapMovement.getCurrMapPosition();
                    if (params) {
                        /** 地図の中心位置・倍率設定を設定する */
                        $('#map_position_is_fixed').val(1);             // 地図デフォルト位置固定(0:無効、1:有効)
                        $('#map_position_lat').val(params.lat);         // 地図デフォルト中心位置(緯度)
                        $('#map_position_lon').val(params.lon);         // 地図デフォルト中心位置(経度)
                        $('#map_position_zoom').val(params.zoom);       // 地図デフォルト倍率
                        /** 作業状態の設定を更新 */
                        setDefaultMapPositionData();
                    }
                }
            }
            if (_refresh_timer_) {
                clearInterval(_refresh_timer_);
                _refresh_timer_ = false;
            }
        });

        /**
         * レイアウト切替ボタン押下時、設定保存
         */
        $('input[name="layout_type"]').on("change", function (e) {
            // バブリング停止
            e.stopPropagation();

            resetTrackingMode();

            setLayoutTypeData();
        });

        /**
         * ラベル表示フラグ変更
         */
        $('input[name="display_label_flg"]').on("change", function (e) {
            // バブリング停止
            e.stopPropagation();
            _zMapMain.mapMovement.setLabelButton($(this).prop('checked'));
        });

        /**
         * 運行終了表示フラグ変更
         */
        $('input[name="display_ended_flg"]').on("change", function (e) {
            // バブリング停止
            e.stopPropagation();
            _zMapMain.mapMovement.setEndedButton($(this).prop('checked'));
        });

        /**
         * リスト切替ボタン押下時イベントの処理を行います。
         */
        $('#search_type_buttons input[type=radio]').parent().on("click", function () {
            /** 現在の表示を初期化 */
            $('#search_input1, #search_input2, #search_input3').val(['']);

            /** 予め各検索条件エリア・リスト表示エリアを非表示化 */
            $('#search_type_area1, #search_type_area2, #search_type_area3').css('display', 'none');

            /** 検索タイプに従い、対応する検索条件エリア・リスト表示エリアを表示 */
            let selected_value = $(this).children('input[type=radio]').val();
            $('#search_type_area' + selected_value).css('display', 'inline');

            /** 絞り込み条件欄の一括クリア */
            clearInputFilter();
            /** フィルターモード一括解除 */
            resetFilterInfoList();
        });

        /**
         * 検索ボタン押下時イベントの処理を行います。(1.車両・乗務員リスト)
         */
        $('#search_button1').on( "click", function(){
            /** 指定条件で車両・乗務員リストのフィルター設定を実行 */
            setFilterInfoListVehicles();
            _is_filter_mode_1_ = true;
        });
        /**
         * 検索ボタン押下時イベントの処理を行います。(2.地点リスト)
         */
        $('#search_button2').on( "click", function(){
            /** 指定条件で地点リストのフィルター設定を実行 */
            setFilterInfoListDestinations();
            _is_filter_mode_2_ = true;
        });
        /**
         * 検索ボタン押下時イベントの処理を行います。(3.免許証期限リスト)
         */
        $('#search_button3').on( "click", function(){
            /** 指定条件で免許証期限リストのフィルター設定を実行 */
            setFilterInfoListLicenseLimits();
            _is_filter_mode_3_ = true;
        });

        /**
         * クリアボタン押下時イベントの処理を行います。(1.車両・乗務員リスト)
         */
        $('#clear_button1').on( "click", function(){
            /** 絞り込み条件欄のクリア */
            clearInputFilterVehicles();
            /** 車両・乗務員リストのフィルター設定を解除 */
            resetFilterInfoListVehicles();
        });
        /**
         * クリアボタン押下時イベントの処理を行います。(2.地点リスト)
         */
        $('#clear_button2').on( "click", function(){
            /** 絞り込み条件欄のクリア */
            clearInputFilterDestinations();
            /** 地点リストのフィルター設定を解除 */
            resetFilterInfoListDestinations();
        });
        /**
         * クリアボタン押下時イベントの処理を行います。(3.免許証期限リスト)
         */
        $('#clear_button3').on( "click", function(){
            /** 絞り込み条件欄のクリア */
            clearInputFilterLicenseLimits();
            /** 免許証期限リストのフィルター設定を解除 */
            resetFilterInfoListLicenseLimits();
        });

        /**
         * リストヘッダクリック(ソート)
         */
        $(document).on('click', 'th.sorting, th.sorting_asc, th.sorting_desc', function(e) {
            let key = $(this).data('sort_key');
            let type = $(this).parents('table').data('type');
            onClickThInfoList(type, "#th_" + key);
        });

        /**
         * リスト行クリック
         * 選択行style＆地図上POPUP制御
         */
        $(document).on('click', '#info_list1_table tbody tr, #info_list2_table tbody tr, #info_list3_table tbody tr', function(e) {
            /* 行のクリックイベント */
            let rowId = $(this).data('row_id');
            let type = $(this).data('type');

            if (!$(this).hasClass('info_list-tr-selected')){
                // init
                $('#info_list1_table tr, #info_list2_table tr, #info_list3_table tr').removeClass('info_list-tr-selected');
                _zMapMain.mapMovement.closeInfoboxVehicleAll();
                _zMapMain.mapMovement.closeInfoboxDestinationAll();

                $(this).addClass('info_list-tr-selected');
                /** 選択行にstyle設定＆対応するアイコンの吹き出しを表示 */
                if (type.toString() === '1') {
                    $('#info_list3_table tr[data-row_id="' + rowId + '"]').addClass('info_list-tr-selected');
                    _zMapMain.mapMovement.openInfoboxVehicle(type, rowId);
                } else if (type.toString() === '2') {
                    _zMapMain.mapMovement.openInfoboxDestination(type, rowId);
                } else if (type.toString() === '3') {
                    $('#info_list1_table tr[data-row_id="' + rowId + '"]').addClass('info_list-tr-selected');
                    _zMapMain.mapMovement.openInfoboxVehicle(type, rowId);
                }


            } else {
                $(this).removeClass('info_list-tr-selected');
                /** 選択行にstyle設定＆対応するアイコンの吹き出しをCLOSE */
                if (type.toString() === '1') {
                    $('#info_list3_table tr[data-row_id="' + rowId + '"]').removeClass('info_list-tr-selected');
                    _zMapMain.mapMovement.closeInfoboxVehicle(type, rowId);
                } else if (type.toString() === '2') {
                    _zMapMain.mapMovement.closeInfoboxDestination(type, rowId);
                } else if (type.toString() === '3') {
                    $('#info_list1_table tr[data-row_id="' + rowId + '"]').removeClass('info_list-tr-selected');
                    _zMapMain.mapMovement.closeInfoboxVehicle(type, rowId);
                }

            }
            return false;
        });

        /**
         * 仮帰庫手続き押下
         * BS-2457 スコープ外の為表示しない。機能追加時に復活させる予定
         */
        // $(document).on('click', '[data-show-temporary-return-list]', function (e) {
        //     // バブリング停止
        //     e.preventDefault();
        //     e.stopPropagation();
        //     let row = $(this).parents('tr');
        //     let type = row.data('type');
        //     let rowId = row.data('row_id');
        //     showTemporaryReturnList(type, rowId);
        // });

        /**
         * 動態要求押下
         */
        $(document).on('click', '[data-request-behavior]', function (e) {
            // バブリング停止
            e.preventDefault();
            e.stopPropagation();
            let row = $(this).parents('tr');
            let action = _movement_map_settings_.url_save_request_behavior_data;
            let data = {
                'section_id': row.data('section_id'),
                'vehicle_id': row.data('vehicle_id'),
            }

            // 動態要求送信
            _ajax.post(action, data, function (results) {
                // 完了メッセージをセットする
                _complete.set(results);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
            return false;
        });

        /**
         * 動画要求押下
         */
        $(document).on('click', '[data-request-video-modal]', function (e) {
            // バブリング停止
            e.preventDefault();
            e.stopPropagation();
            $(this).data('action', _movement_map_settings_.url_setting_request_video);
            let row = $(this).parents('tr');
            _modal.create_with_data(this, 'request-video-modal', {
                'holding_id': row.data('holding_id'),
                'company_id': row.data('company_id'),
                'section_id': row.data('section_id'),
                'vehicle_id': row.data('vehicle_id'),
                'record_id': row.data('record_id')
            }, true, null);
            return false;
        });

        /**
         * 追尾押下
         */
        $(document).on('click', 'input.tracking-vehicle-button', function (e) {
            // バブリング停止
            e.preventDefault();
            e.stopPropagation();
            let row = $(this).parents('tr');

            // toggle
            if ($(this).hasClass('active')) {
                resetTrackingMode();
                $(this).removeClass('active');
            } else {
                if ($('input.tracking-vehicle-button.active').length > 0) {
                    $('input.tracking-vehicle-button').removeClass('active');
                }
                setTrackingMode(row.data('type'), row.data('row_id'));
                $(this).addClass('active');
            }
            return false;
        });

        // 動画要求日時設定保存時
        $(document).on('click', '[data-request-video-save-modal]', function () {
            $(this).data('action', _movement_map_settings_.url_save_request_video_data);
            _modal.submit(this, 'request-video-save-modal', null, null, '-form', true);
        });

        /**
         * (メイン地図)追尾解除ボタン押下時イベントの処理を行います。
         */
        _zMapMain.on("mapMovement:onclickTrackingResetButton",function(e){

            /** 追尾対象フラグを初期化 */
            _tracking_id_ = false;

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * (サブ地図)追尾解除ボタン押下時イベントの処理を行います。
         */
        _zMapSub.on("mapMovementSub:onclickTrackingResetButton",function(e){

            /** 追尾対象フラグを初期化 */
            _tracking_id_ = false;

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * 地図の車両アイコンの吹き出し表示を開いた時のイベント処理を行います。
         */
        _zMapMain.on("markerVehicle:openedInfoBox",function(e, marker_type, marker_id)
        {
            let rowId = marker_id || '';
            let tr1 = $('#info_list1_table tr[data-row_id="' + rowId + '"]');    // 1.車両・乗務員リスト
            let tr3 = $('#info_list3_table tr[data-row_id="' + rowId + '"]');    // 3.免許証期限リスト
            /** 1.車両・乗務員リスト */
            if (tr1) {
                /** 対象行の背景色を選択色に変更 */
                tr1.addClass('info_list-tr-selected');
            }
            /** 3.免許証期限リスト */
            if (tr3) {
                /** 対象行の背景色を選択色に変更 */
                tr3.addClass('info_list-tr-selected');
            }
        });

        /**
         * 地図の車両アイコンの吹き出し表示を閉じた時のイベント処理を行います。
         */
        _zMapMain.on("markerVehicle:closedInfoBox",function(e, marker_type, marker_id)
        {
            let rowId = marker_id || '';
            let tr1 = $('#info_list1_table tr[data-row_id="' + rowId + '"]');    // 1.車両・乗務員リスト
            let tr3 = $('#info_list3_table tr[data-row_id="' + rowId + '"]');    // 3.免許証期限リスト
            /** 1.車両・乗務員リスト  */
            if (tr1) {
                /** 対象行の背景色を選択色をリセット */
                tr1.removeClass('info_list-tr-selected');
            }
            /** 3.免許証期限リスト */
            if (tr3) {
                /** 対象行の背景色を選択色をリセット */
                tr3.removeClass('info_list-tr-selected');
            }
        });

        /**
         * 地図の地点アイコンの吹き出し表示を開いた時のイベント処理を行います。
         */
        _zMapMain.on("markerDestination:openedInfoBox",function(e, marker_type, marker_id)
        {
            let rowId = marker_id || '';
            let tr2 = $('#info_list2_table tr[data-row_id="' + rowId + '"]');    // 2.地点リスト
            /** 2.地点リスト */
            if (tr2) {
                /** 対象行の背景色を選択色に変更 */
                tr2.addClass('info_list-tr-selected');
            }
        });

        /**
         * 地図の地点アイコンの吹き出し表示を閉じた時のイベント処理を行います。
         */
        _zMapMain.on("markerDestination:closedInfoBox",function(e, marker_type, marker_id)
        {
            let rowId = marker_id || '';
            let tr2 = $('#info_list2_table tr[data-row_id="' + rowId + '"]');    // 2.地点リスト
            /** 2.地点リスト */
            if (tr2) {
                /** 対象行の背景色を選択色をリセット */
                tr2.removeClass('info_list-tr-selected');
            }
        });

        /**
         * 地図の中心位置・倍率設定ボタン押下時イベントの処理を行います（設定中→解除中に変化する）。
         */
        _zMapMain.on("mapMovement:onclickMapPositionFixedButton",function(e)
        {
            /** 地図の中心位置・倍率設定を解除する */
            $('#map_position_is_fixed').val(0);                 // 地図デフォルト位置固定(0:無効、1:有効)
            $('#map_position_lat').val(null);                   // 地図デフォルト中心位置(緯度)
            $('#map_position_lon').val(null);                   // 地図デフォルト中心位置(経度)
            $('#map_position_zoom').val(null);                  // 地図デフォルト倍率

            /** 作業状態の設定を更新 */
            setDefaultMapPositionData();

            /** 解除ボタンに切替 */
            _zMapMain.mapMovement.showMapPositionButton(2);

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * 地図の中心位置・倍率解除ボタン押下時イベントの処理を行います（解除中→設定中に変化する）。
         */
        _zMapMain.on("mapMovement:onclickMapPositionResetButton",function(e)
        {
            /** 現在の地図の中心位置・倍率を取得 */
            let params = _zMapMain.mapMovement.getCurrMapPosition();
            if (params) {
                /** 地図の中心位置・倍率設定を設定する */
                $('#map_position_is_fixed').val(1);             // 地図デフォルト位置固定(0:無効、1:有効)
                $('#map_position_lat').val(params.lat);         // 地図デフォルト中心位置(緯度)
                $('#map_position_lon').val(params.lon);         // 地図デフォルト中心位置(経度)
                $('#map_position_zoom').val(params.zoom);       // 地図デフォルト倍率

                /** 作業状態の設定を更新 */
                setDefaultMapPositionData();

                /** 設定ボタンに切替 */
                _zMapMain.mapMovement.showMapPositionButton(1);
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /** 内部変数初期化 */
        _movement_settings_ = false;
        _movement_map_data_ = false;
        _tracking_id_       = false;

        // データ取得＆表示処理
        initialAll()
    }

    /**
     * データ取得＆表示処理
     */
    function initialAll()
    {
        /** 地図初期化 */
        initializeMap();

        /** 情報リスト初期化処理 */
        initializeInfoList();

        /** 絞り込み条件欄の一括クリア */
        clearInputFilter();

        /** 画面リサイズ処理 */
        resizeDisplay();

        /** 動態表示データ取得 */
        getMovementMapData(false);
    }

    /**
     * 地図デフォルト中心位置・倍率の設定処理を行います。
     */
    function setDefaultMapPositionData()
    {
        if (_movement_map_settings_) {
            let map_position_is_fixed = $('#map_position_is_fixed').val() || '';              // 地図デフォルト位置固定(0:無効、1:有効)
            let map_position_lat = $('#map_position_lat').val() || '';                   // 地図デフォルト中心位置(緯度)
            let map_position_lon = $('#map_position_lon').val() || '';                   // 地図デフォルト中心位置(経度)
            let map_position_zoom = $('#map_position_zoom').val() || '';                  // 地図デフォルト倍率

            $.ajax({
                url: _movement_map_settings_.url_set_default_map_position_data,
                type: 'post',
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('input[name="_token"]').val()
                },
                data: {
                    map_position_is_fixed: map_position_is_fixed,
                    map_position_lat: map_position_lat,
                    map_position_lon: map_position_lon,
                    map_position_zoom: map_position_zoom,
                },
            }).done(function (data) {
                /** エラー時は何もしない */
                if (data && data.errors && Object.keys(data.errors).length) {
                }
            });
        }
    }

    /**
     * レイアウト切替処理
     * @param {*} layout_type
     */
    function setLayoutType(layout_type)
    {
        return;
    }

    /**
     * 画面リサイズ処理を行います。
     */
    function resizeDisplay() {

        let windowHeight  = $(window).height();
        let headerHeight  = $('.main-header').first().height();
        let titleHeight   = 0;      //$('.content-header').first().height();
        let menuHeight    = $('.movement-menu').height();
        let footerHeight  = 0;      //$('.main-footer').first().height();
        let paddingHeight = 42;     //58;
        let totalHeight   = windowHeight - (headerHeight + titleHeight + menuHeight + footerHeight) - paddingHeight;

        $('#main_container').height(totalHeight);
        $('#left_area').height(totalHeight);
        $('#right_area').height(totalHeight);

    }

    /**
     * 情報表示エリアを表示します。
     * @param {*} layout_type
     */
    function showRightAreaContainer(layout_type){

        /** ボタンの表示・非表示切替え */
        if ((layout_type.toString() || '2') === '1') {
            _zMapMain.mapMovement.hideRightareaButton();
        } else {
            _zMapMain.mapMovement.showRightareaButton(2);
        }

        /** リサイズバーを表示(左右エリア間) */
        $('#left_area').resizable({
            handles: 'e',
            resize: function( event, ui ) {
                _zMapMain.mapMovement.resizeMap();
                _zMapSub.mapMovementSub?.resizeMap();
            },
            stop: function( event, ui ) {
                _zMapMain.mapMovement.resizeMap();
                _zMapSub.mapMovementSub?.resizeMap();
            },
        });

        /** リサイズバーを表示(右側 上下エリア間) */
        if ((layout_type || 2) == 1) {

            $("#right_area_upper").resizable({
                handles: 's',
                resize: function( event, ui ) {
                    _zMapSub.mapMovementSub?.resizeMap();
                },
                stop: function( event, ui ) {
                    _zMapSub.mapMovementSub?.resizeMap();
                },
            });
            _zMapSub.mapMovementSub?.resizeMap();
        }

        /** 左側エリアを縮小 */
        $('#left_area').animate({width: "55%"}, 500, function(){
            _zMapMain.mapMovement.resizeMap();
        });

        /** 右側エリアを拡大 */
        $('#right_area').show().animate({width: "45%"}, 500, function(){
            _zMapSub.mapMovementSub?.resizeMap();
        });

   }

    /**
     * 情報表示エリアを非表示にします。
     * @param {*} layout_type
     * @param {*} duration
     */
    function hideRightAreaContainer(layout_type, duration = 500){

        /** ボタンの表示・非表示切替え */
        if ((layout_type.toString() || '2') === '1') {
            _zMapMain.mapMovement.hideRightareaButton();
        } else {
            _zMapMain.mapMovement.showRightareaButton(1);
        }

        /** リサイズバーをクリア(左右エリア間) */
        if( $('#left_area').hasClass('ui-resizable')){
            $('#left_area').resizable('destroy');
        }

        /** リサイズバーをクリア(右側 上下エリア間) */
        if( $('#right_area_upper').hasClass('ui-resizable')){
            $('#right_area_upper').resizable('destroy');
        }

        /** 右側エリアを縮小 */
        $('#right_area').animate({width: "0%"}, duration, function(){
            $('#right_area').hide();
        });

        /** 左側エリアを拡大 */
        $('#left_area').animate({width: "100%"}, duration, function(){
            _zMapMain.mapMovement.resizeMap();
        });
    }

    /**
     * 地図を初期化します。
     */
    function initializeMap()
    {
        _zMapMain.mapMovement.init(_movement_map_settings_);

        _zMapSub.empty();
        _zMapSub.mapMovementSub?.(_movement_map_settings_);
    }

    /**
     * 検索結果リストを初期化します。
     */
    function initializeInfoList(){

        /** 車両・乗務員リストクリア */
        clearInfoListVehicles();
        /** 地点リストクリア */
        clearInfoListDestinations();
        /** 免許証期限リストクリア */
        clearInfoListLicenseLimits();

    }

    /**
     * 動態表示データを取得します。
     * @param {*} is_refresh_data
     */
    function getMovementMapData(is_refresh_data)
    {
        let action = extend_url_query(_movement_map_settings_.url_get_movement_map_data);
        let params = [];
        _ajax.background(action, params, function(data) {

            /** 地図の中心位置・倍率のデフォルト値設定の取得 */
            let map_position_params   =
            {
                is_fixed: $('#map_position_is_fixed').val() || '',  // 地図デフォルト位置固定(0:無効、1:有効)
                lat: $('#map_position_lat').val() || '',            // 地図デフォルト中心位置(緯度)
                lon: $('#map_position_lon').val() || '',            // 地図デフォルト中心位置(経度)
                zoom: $('#map_position_zoom').val() || '',          // 地図デフォルト倍率
            };

            /** 各リストの現在有効になっている並べ替え条件を取得 */
            let p1 = getSortParamInfoList('info_list1');
            let p2 = getSortParamInfoList('info_list2');
            let p3 = getSortParamInfoList('info_list3');

            /** 並べ替えデータ取得 */
            data['list_vehicles'] = getSortDataVehicles(data['list_vehicles'], p1.sort_column, p1.sort_type);
            data['list_destinations'] = getSortDataDestinations(data['list_destinations'], p2.sort_column, p2.sort_type);
            data['list_license_limits'] = getSortDataLicenseLimits(data['list_license_limits'], p3.sort_column, p3.sort_type);

            // データ保持
            _movement_map_data_ = data;


            if (!is_refresh_data) {
                /** 初回表示時 */
                createInfoList(data);

                _zMapMain.mapMovement.setMapData(data, _tracking_id_, map_position_params);

            } else {
                /** 表示更新時 */
                refreshInfoList(data);

                _zMapMain.mapMovement.refreshMapData(data, _tracking_id_, map_position_params);
            }

            /** 並べ替えアイコンを設定 */
            setSortIconInfoList(p1.sort_column, p1.sort_type, 'info_list1');
            setSortIconInfoList(p2.sort_column, p2.sort_type, 'info_list2');
            setSortIconInfoList(p3.sort_column, p3.sort_type, 'info_list3');

            /** 定周期で当該処理を実行 */
            if (!_refresh_timer_) {
                _refresh_timer_ = setInterval(function(){
                    getMovementMapData(true);
                }, _refresh_interval_);
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
            if (_refresh_timer_) {
                clearInterval(_refresh_timer_);
                _refresh_timer_ = false;
            }
        });
    }

    /**
    * 表示リストを生成します。
    * @param {*} data
    */
    function createInfoList(data)
    {
        _movement_settings_ = data['movement_settings'];
        /** 車両・乗務員リスト生成 */
        createInfoListVehicles(data['list_vehicles']);
        /** 地点リスト生成 */
        createInfoListDestinations(data['list_destinations']);
        /** 免許証期限リスト生成 */
        createInfoListLicenseLimits(data['list_license_limits']);
    }

    /**
    * 表示リストを更新します。
    * @param {*} data
    */
    function refreshInfoList(data){

        /** 車両・乗務員リスト更新 */
        refreshInfoListVehicles(data['list_vehicles']);
        /** 地点リスト更新 */
        refreshInfoListDestinations(data['list_destinations']);
        /** 免許証期限リスト更新 */
        refreshInfoListLicenseLimits(data['list_license_limits']);
    }

    /**
    * 車両・乗務員リストを生成します。
    * @param {*} list
    */
    function createInfoListVehicles(list)
    {
        if ($(list).length === 0) {
            return;
        }
        // init
        let listBlock = $('#info_list_vehicles');
        listBlock.empty();

        // setting
        let settingKey = 'info_list_settings1';
        let messages = _movement_map_settings_.messages;
        let listSettings = messages.info_list1;
        let table  = $('<table id="info_list1_table" class="table table-bordered table-hover dataTable info_list-table" data-type="1" role="list"></table>');

        /** ヘッダ部 **/
        let thead = $('<thead></thead>');
        let tr = $('<tr role="row"></tr>');

        // tr処理
        let is_visible_column = {}; // カラム表示非表示設定
        $.each(listSettings, function(key, value) {
            let sorting = (value.hasOwnProperty('sorting') && value.sorting === true) ? 'sorting' : 'sorting_disabled';
            is_visible_column[key] = value.hasOwnProperty('setting_exclude') ? true : checkMovementSetting(null, settingKey, key, _movement_settings_);
            tr.append($('<th id="th_' + key + '" class="' + sorting + (!is_visible_column[key] ? ' d-none' : '') + '" data-sort_key="' + key + '">' + value.label + '</th>'))
        });
        thead.append(tr);
        table.append(thead);

        /** ボディ部 **/
        table.append($('<tbody></tbody>'));
        listBlock.append(table);

        // レコード処理(更新共通)
        refreshInfoListVehicles(list, is_visible_column);
    }

    /**
    * 車両・乗務員リストを更新します。
    * @param {*} list
    * @param {*} is_visible_column
    */
    function refreshInfoListVehicles(list, is_visible_column = {})
    {
        // console.info('----refreshInfoListVehicles');
        //------------------------------------------------------------
        let settingKey = 'info_list_settings1';
        let messages = _movement_map_settings_.messages;
        let listSettings   = messages.info_list1;
        let _type = 1; // 1.車両・乗務員リスト
        //------------------------------------------------------------

        // 表示非表示取得無ければ取得する
        if (Object.keys(is_visible_column).length === 0) {
            $.each(listSettings, function(key, value) {
                is_visible_column[key] = value.hasOwnProperty('setting_exclude') ? true : checkMovementSetting(null, settingKey, key, _movement_settings_);
            });
        }

        // ツールチップ削除
        $('#info_list_area1').find('[data-toggle="tooltip"]').tooltip('dispose');

        /** 既存行の更新 or 新規行の追加 */
        $(list).each(function(i, item) {
            let _rowId = item.record_id;
            // 表示データ編集
            let _display = {};
            _display['vehicle_code'] = (item.vehicle_code || messages.is_not_exists_master_message);
            _display['vehicle_name'] = (item.vehicle_name || messages.is_not_exists_master_message);
            _display['driver_code'] = (item.driver_code || messages.is_not_exists_master_message);
            _display['driver_name'] = (item.driver_name || '');
            _display['speed'] = ((item.average_speed.toString() === '99') ? '0' : (item.average_speed.toString() || '')) + messages.speed_unit;
            _display['warning_status'] = getVehicleStatusMessage(item.warning_status, messages);
            _display['vehicle_status'] = getVehicleStatusMessage(item.vehicle_status2, messages);
            _display['luggage_status'] = getLuggageStatusMessage(item.luggage_status, messages);
            _display['section_name'] = (item.section_name || '');
            _display['ig_onoff'] = (item.ig_onoff || '');
            _display['vehicle_classification'] = (item.vehicle_classification_name || '');
            _display['temperature1'] = item.temperature1 === '3276.7' ? '--' : (item.temperature1 || messages.is_not_exists_master_message);
            _display['temperature2'] = item.temperature2 === '3276.7' ? '--' : (item.temperature2 || messages.is_not_exists_master_message);
            _display['temperature3'] = item.temperature3 === '3276.7' ? '--' : (item.temperature3 || messages.is_not_exists_master_message);
            _display['temperature4'] = item.temperature4 === '3276.7' ? '--' : (item.temperature4 || messages.is_not_exists_master_message);

            // tr生成
            let tr = $('#info_list1_table tbody tr[data-row_id="' + _rowId + '"]');
            if (tr.length > 0) {
                /** 該当record_idがある場合td上書き */
                // td処理
                $.each(listSettings, function(key, value) {
                    tr.find('.display_' + key).empty();
                    if (key === 'license_certification_status') {
                        let icon = getLicenseCertificationIcon(item.license_certification_status);
                        tr.find('.display_' + key).append(
                            (icon ? '<input type="image" class="icon-' + key +'" src="' + icon + '" onclick="event.stopPropagation();return false;" alt=""/>' : '')
                        ).attr('title', value.tooltip + '：' + (item.license_limit || '')   + '\n\n'
                            + getLicenseCertificationMessageByHistory(item.license_certification_status_history));

                    } else if (key === 'alc_concentration') {
                        let alc_class = item.alc_concentration > messages.alc_limit ? ' alc-ng' : '';
                        tr.find('.display_' + key).removeClass('alc-ng').addClass(alc_class).append(
                            '<a href="#" class="alc_link" data-alc-arr=' + "'" + JSON.stringify(item.alc_concentration_arr) + "'" + ' onclick="return false;">' +
                            (item.alc_concentration >= 0 ? (item.alc_concentration / 1000).toFixed(3) + ' ' + messages.alc_unit : '') + '</a>'
                        );

                    } else if (key === 'temporary_return') {
                        tr.find('.display_' + key).append(
                            ((item.vehicle_status || '').toString() !== '99' ?
                                '<a data-show-temporary-return-list="show-temporary-return-list" href="javascript:void(0);" role="button" title="'+ value.tooltip + '">' +
                                '<i class="fa fa-edit"></i>' +
                                '<span class="button_text"></span></a>' : '')
                        );

                    } else if (key === 'request_movement') {
                        tr.find('.display_' + key).append(
                            '<a data-request-behavior="request-behavior" href="#" role="button" title="'+ value.tooltip + '">' +
                            '<i class="fa fa-truck"></i><span class="button_text"></span></a>'
                        );

                    } else if (key === 'request_video') {
                        const tooltip = (item?.is_requestable ?? false) ? value.tooltip.realtime_request_enabled : value.tooltip.realtime_request_disabled;
                        const icon = (item?.is_requestable ?? false)
                            ? '<i class="fa fa-video-camera"></i>'
                            : '<img src="/assets/img/movement/realtime_request_disabled_icon.png" style="width: 1.25em; height: auto; vertical-align: baseline;"></img>';
                        tr.find('.display_' + key).append(
                            '<a data-request-video-modal="#request-video-modal" href="javascript:void(0);" class="info_list-table-td-btn-mark" role="button"' +
                                'data-toggle="tooltip"' +
                                'data-placement="top"' +
                                'title="' + tooltip + '">' +
                            icon + '<span class="button_text"></span></a>'
                        );

                    } else if (key === 'tracking') {
                        const active = _rowId === _tracking_id_ ? ' active' : '';
                        tr.find('.display_' + key).append(
                            '<input type="image" id="tracking_button' + i + '" class="tracking-vehicle-button' + active + '" src="' + TRACKING_VEHICLE_ICON + '"  alt=""/>'
                        );

                    } else {
                        tr.find('.display_' + key).text(_display[key]);
                    }
                    if ((value.hasOwnProperty('param') && value.param === true)) {
                        // 内部パラメタ項目data属性セット
                        tr.attr('data-' + key, (item[key] || ''));
                    }
                });

            } else {
                /** 該当IDのレコードがない場合tr追加 */
                tr = $('<tr role="row" data-type="' + _type + '" data-row_id="' + (_rowId || '') + '"></tr>');
                // td処理
                $.each(listSettings, function(key, value) {
                    if (key === 'license_certification_status') {
                        let icon = getLicenseCertificationIcon(item.license_certification_status);
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '" title="' + value.tooltip + '：' + (item.license_limit || '')   + '\n\n'
                            + getLicenseCertificationMessageByHistory(item.license_certification_status_history) + '">' +
                            (icon ? '<input type="image" class="icon-' + key + '" src="' + icon + '" onclick="event.stopPropagation();return false;" alt=""/>' : '') +
                            '</td>'));

                    } else if (key === 'alc_concentration') {
                        let alc_class = item.alc_concentration > messages.alc_limit ? ' text-danger text-bold' : '';
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + alc_class + '">' +
                            '<a href="#" class="alc_link" data-alc-arr=' + "'" + JSON.stringify(item.alc_concentration_arr) + "'" + ' onclick="return false;">' +
                            (item.alc_concentration >= 0 ? (item.alc_concentration / 1000).toFixed(3) + ' ' + messages.alc_unit : '') +
                            '</a></td>'));

                    } else if (key === 'temporary_return') {
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '">' +
                            ((item.vehicle_status || '').toString() !== '99' ?
                                '<a data-show-temporary-return-list="show-temporary-return-list" href="javascript:void(0);" class="info_list-table-td-btn-mark" role="button" title="'+ value.tooltip + '">' +
                                '<i class="fa fa-edit"></i></a>' : '') +
                            '</td>'));

                    } else if (key === 'request_movement') {
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '">' +
                            '<a data-request-behavior="request-behavior" href="javascript:void(0);" class="info_list-table-td-btn-mark" role="button" title="'+ value.tooltip + '">' +
                            '<i class="fa fa-truck"></i></span></a>' +
                            '</td>'));

                    } else if (key === 'request_video') {
                        const tooltip = (item?.is_requestable ?? false) ? value.tooltip.realtime_request_enabled : value.tooltip.realtime_request_disabled;
                        const icon = (item?.is_requestable ?? false)
                            ? '<i class="fa fa-video-camera"></i>'
                            : '<img src="/assets/img/movement/realtime_request_disabled_icon.png" style="width: 1.25em; height: auto; vertical-align: baseline;"></img>';
                        tr.append($('<td class="display_' + key+ ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '">' +
                            '<a data-request-video-modal="#request-video-modal" href="javascript:void(0);" class="info_list-table-td-btn-mark" role="button"' +
                                'data-toggle="tooltip"' +
                                'data-placement="top"' +
                                'title="' + tooltip + '">' +
                            icon + '</a>' +
                            '</td>'));
                    } else if (key === 'tracking') {
                        tr.append($('<td class="display_' + key + ' p-0 text-center' + '">' +
                            '<input type="image" id="tracking_button' + i + '" class="tracking-vehicle-button" src="' + TRACKING_VEHICLE_ICON + '"  alt=""/>' +
                            '</td>'));

                    } else {
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '">' + (_display[key] || '') + '</td>'));
                    }
                    if ((value.hasOwnProperty('param') && value.param === true)) {
                        // 内部パラメタ項目data属性セット
                        tr.attr('data-' + key, (item[key] || ''));
                    }
                });
                if ($('#info_list1_table tbody tr').eq(i + 1).length > 0) {
                    // trあれば次の行に追加
                    $('#info_list1_table tbody tr').eq(i + 1).after(tr);
                } else {
                    // tr無ければtbodyに追加
                    $('#info_list1_table tbody').append(tr);
                }
            }
            // リスト表示設定以外の内部パラメタ項目data属性追加
            tr.attr('data-holding_id', (item.holding_id || ''));
            tr.attr('data-company_id', (item.company_id || ''));
            tr.attr('data-section_id', (item.section_id || ''));
            tr.attr('data-vehicle_id', (item.vehicle_id || ''));
            tr.attr('data-driver_id', (item.driver_id || ''));
            tr.attr('data-updated_at', (item.updated_at || ''));
        });

        // ツールチップ実行
        $('#info_list_area1').find('[data-toggle="tooltip"]').tooltip({container: '#info_list_area1'});

        let _dataTr = $('#info_list1_table tbody tr');
        /** データが存在しない既存行要素の削除 */
        _dataTr.each(function() {
            let _rowId = $(this).attr('data-row_id') || '';
            let exists_id   = (list) ? list.filter((x) => (x.record_id.toString() === _rowId))[0] : null;
            if (!exists_id && _rowId !== '') {
                $(this).remove();
            }
        });

        /** 並び順の補正(※テーブルとデータで並び順以外は、件数・内容とも完全に一致していることを前提とする) */
        $(list).each(function(i, item) {
            let _rowId1 = item.record_id;
            let _tr1 = (_dataTr.eq(i + 1) || false);
            let _rowindex1 = i;
            let _tr2 = false;
            let _rowindex2 = 0;
            _dataTr.each(function() {
                if (typeof $(this).attr('data-row_id') !== 'undefined' && $(this).attr('data-row_id') !== false) {
                    let _rowId2 = $(this).attr('data-row_id') || '';
                    if (_rowId1 === _rowId2) {
                        if (_rowindex1 !== _rowindex2){
                            _tr2 = $(this);
                        }
                        return;
                    }
                    _rowindex2++;
                }
            });
            if (_tr1 && _tr1.length && _tr2 && _tr2.length){
                _tr2.insertBefore(_tr1);
            }
        });

        /** フィルターモード中ならば指定条件で車両・乗務員リストのフィルター設定を実行 */
        if(_is_filter_mode_1_) {
            setFilterInfoListVehicles();
        }
    }

    /**
    * 地点リストを生成します。
    * @param {*} list
    */
    function createInfoListDestinations(list)
    {
        // init
        let listBlock = $('#info_list_destinations');
        listBlock.empty();
        if ($(list).length === 0) {
            return;
        }

        // setting
        let settingKey = 'info_list_settings2';
        let messages = _movement_map_settings_.messages;
        let listSettings = messages.info_list2;
        let table  = $('<table id="info_list2_table" class="table table-bordered table-hover dataTable info_list-table" data-type="2" role="list"></table>');

        /** ヘッダ部 **/
        let thead = $('<thead></thead>');
        let tr = $('<tr role="row"></tr>');

        // tr処理
        let is_visible_column = {}; // カラム表示非表示設定
        $.each(listSettings, function(key, value) {
            let sorting = (value.hasOwnProperty('sorting') && value.sorting === true) ? 'sorting' : 'sorting_disabled';
            is_visible_column[key] = value.hasOwnProperty('setting_exclude') ? true : checkMovementSetting(null, settingKey, key, _movement_settings_);
            tr.append($('<th id="th_' + key + '" class="' + sorting + (!is_visible_column[key] ? ' d-none' : '') + '" data-sort_key="' + key + '">' + value.label + '</th>'))
        });
        thead.append(tr);
        table.append(thead);

        /** ボディ部 **/
        table.append($('<tbody></tbody>'));
        listBlock.append(table);

        // レコード処理(更新共通)
        refreshInfoListDestinations(list, is_visible_column);
    }

    /**
    * 地点リストを更新します。
     * @param {*} list
     * @param {*} is_visible_column
    */
    function refreshInfoListDestinations(list, is_visible_column = {})
    {
        //------------------------------------------------------------
        let settingKey = 'info_list_settings2';
        let messages = _movement_map_settings_.messages;
        let listSettings = messages.info_list2;
        let _type = 2;                                                        // 2.地点リスト
        //------------------------------------------------------------

        // 表示非表示取得無ければ取得する
        if (Object.keys(is_visible_column).length === 0) {
            $.each(listSettings, function(key, value) {
                is_visible_column[key] = value.hasOwnProperty('setting_exclude') ? true : checkMovementSetting(null, settingKey, key, _movement_settings_);
            });
        }

        /** 既存行の更新or新規行の追加 */
        $(list).each(function(i, item) {
            let _rowId = item.id;
            // 表示カラム編集
            let _display = {};
            _display['destination_code'] = (item.code || '');
            _display['destination_name'] = (item.name || '');
            _display['address'] = messages.zipcode + (toZipcodeFormat(item.zipcode || '')) + (item.prefecture || '') + (item.municipality || '') + (item.address || '');
            _display['phone_number'] = (item.phone_number || '');
            _display['destination_type'] = getDestinationTypeMessage(item.destination_type, messages);

            let tr  = $('#info_list2_table tbody tr[data-row_id="' + _rowId + '"]');
            if (tr.length > 0) {
                /** 該当record_idがある場合td上書き */
                // td処理
                $.each(listSettings, function(key, value) {
                    tr.find('.display_' + key).empty();
                    tr.find('.display_' + key).text(_display[key]);
                    if ((value.hasOwnProperty('param') && value.param === true)) {
                        // 内部パラメタ項目data属性セット
                        tr.attr('data-' + key, (item[key] || ''));
                    }
                });
            } else {
                /** 該当IDのレコードがない場合tr追加 */
                tr = $('<tr role="row" data-type="' + _type + '" data-row_id="' + (_rowId || '') + '"></tr>');
                // td処理
                $.each(listSettings, function(key, value) {
                    tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '">' + (_display[key] || '') + '</td>'));
                    if ((value.hasOwnProperty('param') && value.param === true)) {
                        // 内部パラメタ項目data属性セット
                        tr.attr('data-' + key, (item[key] || ''));
                    }
                });
                if ($('#info_list2_table tbody tr').eq(i + 1).length > 0) {
                    // trあれば次の行に追加
                    $('#info_list2_table tbody tr').eq(i + 1).after(tr);
                } else {
                    // tr無ければtbodyに追加
                    $('#info_list2_table tbody').append(tr);
                }
            }
        });

        let _dataTr = $('#info_list2_table tbody tr');
        /** データが存在しない既存行要素の削除 */
        _dataTr.each(function() {
            let _rowId = $(this).attr('data-row_id') || '';
            let exists_id = (list) ? list.filter((x) => (x.id.toString() === _rowId))[0] : null;
            if (!exists_id && _rowId !== '') {
                $(this).remove();
            }
        });

        /** 並び順の補正(※テーブルとデータで並び順以外は、件数・内容とも完全に一致していることを前提とする) */
        $(list).each(function(i, item) {
            let _rowId1 = item.id.toString();
            let _tr1 = (_dataTr.eq(i + 1) || false);
            let _rowindex1 = i;
            let _tr2 = false;
            let _rowindex2 = 0;
            _dataTr.each(function() {
                if (typeof $(this).attr('data-row_id') !== 'undefined' && $(this).attr('data-row_id') !== false) {
                    let _rowId2 = $(this).attr('data-row_id') || '';
                    if (_rowId1 === _rowId2) {
                        if (_rowindex1 !== _rowindex2){
                            _tr2 = $(this);
                        }
                        return;
                    }
                    _rowindex2++;
                }
            });
            if (_tr1 && _tr1.length && _tr2 && _tr2.length){
                _tr2.insertBefore(_tr1);
            }
        });

        /** フィルターモード中ならば指定条件で地点リストのフィルター設定を実行 */
        if(_is_filter_mode_2_) {
            setFilterInfoListDestinations();
        }
    }

    /**
    * 免許証期限リストを生成します。
    * @param {*} list
    */
    function createInfoListLicenseLimits(list)
    {
        // init
        let listBlock = $('#info_list_license_limits');
        listBlock.empty();
        if ($(list).length === 0) {
            return;
        }

        // setting
        let settingKey = 'info_list_settings3';
        let messages = _movement_map_settings_.messages;
        let listSettings = messages.info_list3;
        let table  = $('<table id="info_list3_table" class="table table-bordered table-hover dataTable info_list-table" data-type="3" role="list"></table>');

        /** ヘッダ部 **/
        let thead = $('<thead></thead>');
        let tr = $('<tr role="row"></tr>');

        // tr処理
        let is_visible_column = {}; // カラム表示非表示設定
        $.each(listSettings, function(key, value) {
            let sorting = (value.hasOwnProperty('sorting') && value.sorting === true) ? 'sorting' : 'sorting_disabled';
            is_visible_column[key] = value.hasOwnProperty('setting_exclude') ? true : checkMovementSetting(null, settingKey, key, _movement_settings_);
            tr.append($('<th id="th_' + key + '" class="' + sorting + (!is_visible_column[key] ? ' d-none' : '') + '" data-sort_key="' + key + '">' + value.label + '</th>'))
        });
        thead.append(tr);
        table.append(thead);

        /** ボディ部 **/
        table.append($('<tbody></tbody>'));
        listBlock.append(table);

        // レコード処理(更新共通)
        refreshInfoListLicenseLimits(list, is_visible_column);
    }

    /**
    * 免許証期限リストを更新します。
     * @param {*} list
     * @param {*} is_visible_column
    */
    function refreshInfoListLicenseLimits(list, is_visible_column = {})
    {
        //------------------------------------------------------------
        let settingKey = 'info_list_settings3';
        let messages = _movement_map_settings_.messages;
        let listSettings   = messages.info_list3;
        let _type = 3;
        //------------------------------------------------------------

        // 表示非表示取得無ければ取得する
        if (Object.keys(is_visible_column).length === 0) {
            $.each(listSettings, function(key, value) {
                is_visible_column[key] = value.hasOwnProperty('setting_exclude') ? true : checkMovementSetting(null, settingKey, key, _movement_settings_);
            });
        }

        /** 既存行の更新or新規行の追加 */
        $(list).each(function(i, item) {
            let _rowId = item.record_id;
            // 表示カラム編集
            let _display = {};
            _display['driver_code'] = (item.driver_code || '');
            _display['driver_name'] = (item.driver_name || '');
            _display['license_grant'] = (item.license_grant || '');
            _display['license_limit'] = (item.license_limit || '');
            _display['license_limit_status'] = getLicenseLimitStatusMessage(item.license_limit_status, messages);
            _display['section_name'] = (item.section_name || '');

            let tr  = $('#info_list3_table tbody tr[data-row_id="' + _rowId + '"]');
            if (tr.length > 0) {
                /** 該当record_idがある場合td上書き */
                // td処理
                $.each(listSettings, function(key, value) {
                    tr.find('.display_' + key).empty();
                    if (key === 'license_certification_status') {
                        let icon = getLicenseCertificationIcon(item.license_certification_status);
                        tr.find('.display_' + key).append(
                            (icon ? '<input type="image" class="icon-' + key +'" src="' + icon + '" onclick="event.stopPropagation();return false;"/>' : '')
                        ).attr('title', value.tooltip + '：' + (item.license_limit || '')   + '\n\n' +
                        getLicenseCertificationMessageByHistory(item.license_certification_status_history));

                    } else if (key === 'tracking') {
                        tr.find('.display_' + key).append(
                            '<input type="image" id="tracking_button' + i + '" class="tracking-vehicle-button" src="' + TRACKING_VEHICLE_ICON + '" onclick="movement_set_tracking_mode(\'' + _type + '\', \'' + _rowId + '\');event.stopPropagation();return false;" />'
                        );

                    } else {
                        tr.find('.display_' + key).text(_display[key]);
                    }
                    if ((value.hasOwnProperty('param') && value.param === true)) {
                        // 内部パラメタ項目data属性セット
                        tr.attr('data-' + key, (item[key] || ''));
                    }
                });
            } else {
                /** 該当IDのレコードがない場合tr追加 */
                tr = $('<tr role="row" data-type="' + _type + '" data-row_id="' + (_rowId || '') + '" class="text-danger text-bold"></tr>');
                // td処理
                $.each(listSettings, function(key, value) {
                    if (key === 'license_certification_status') {
                        let icon = getLicenseCertificationIcon(item.license_certification_status);
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '"' +
                            ' title="' + value.tooltip + '：' + (item.license_limit || '')   + '\n\n' +
                            getLicenseCertificationMessageByHistory(item.license_certification_status_history) + '">' +
                            (icon ? '<input type="image" class="icon-' + key + '" src="' + icon + '" onclick="event.stopPropagation();return false;" alt=""/>' : '') +
                            '</td>'));

                    } else if (key === 'tracking') {
                        tr.append($('<td class="display_' + key + ' p-0 text-center' + '">' +
                            '<input type="image" id="tracking_button' + i + '" class="tracking-vehicle-button" src="' + TRACKING_VEHICLE_ICON + '"  alt=""/>' +
                            '</td>'));

                    } else {
                        tr.append($('<td class="display_' + key + ' ' + (value.td_class || '') + (!is_visible_column[key] ? ' d-none' : '') + '">' + (_display[key] || '') + '</td>'));
                    }
                    if ((value.hasOwnProperty('param') && value.param === true)) {
                        // 内部パラメタ項目data属性セット
                        tr.attr('data-' + key, (item[key] || ''));
                    }
                });
                if ($('#info_list3_table tbody tr').eq(i + 1).length > 0) {
                    // trあれば次の行に追加
                    $('#info_list3_table tbody tr').eq(i + 1).after(tr);
                } else {
                    // tr無ければtbodyに追加
                    $('#info_list3_table tbody').append(tr);
                }
            }
        });

        /** データが存在しない既存行の削除 */
        let _dataTr = $('#info_list3_table tbody tr');
        _dataTr.each(function(){
            let _rowId = $(this).attr('data-row_id') || '';
            let exists_id   = (list) ? list.filter((x) => (x.record_id.toString() === _rowId))[0] : null;
            if (!exists_id && _rowId !== '') {
                $(this).remove();
            }
        });

        /** 並び順の補正(※テーブルとデータで並び順以外は、件数・内容とも完全に一致していることを前提とする) */
        $(list).each(function(i, item) {
            let _rowId1 = item.record_id.toString();                                    // 記録ID
            let _tr1 = _dataTr.eq(i + 1) || false;
            let _rowindex1 = i;
            let _tr2 = false;
            let _rowindex2 = 0;
            _dataTr.each(function() {
                if (typeof $(this).attr('data-row_id') !== 'undefined' && $(this).attr('data-row_id') !== false) {
                    let _rowId2 = $(this).attr('data-row_id') || '';
                    if (_rowId1 === _rowId2) {
                        if (_rowindex1 !== _rowindex2){
                            _tr2 = $(this);
                        }
                        return;
                    }
                    _rowindex2 ++;
                }
            });
            if (_tr1 && _tr1.length && _tr2 && _tr2.length){
                _tr2.insertBefore(_tr1);
            }
        });

        /** フィルターモード中ならば指定条件で免許証期限リストのフィルター設定を実行 */
        if(_is_filter_mode_3_) {
            setFilterInfoListLicenseLimits();
        }
    }

    /**
     * 追尾モードを有効にします。
     * @param {*} type
     * @param {*} rowId
     */
    function setTrackingMode(type, rowId)
    {
        let tr = $('#info_list' + type + '_table tbody tr[data-row_id="' + rowId + '"]');
        if (tr) {
            let record_id = rowId;

            if (_movement_map_data_) {
                _tracking_id_   = record_id;
                _zMapMain.mapMovement.setTrackingMode(_movement_map_data_, _tracking_id_);
            }
        }
        return false;
    }

    /**
     * 追尾モードを解除します。
     */
    function resetTrackingMode()
    {
        _tracking_id_ = false;
        _zMapMain.mapMovement.resetTrackingMode();

        $('input.tracking-vehicle-button').removeClass('active');
        return false;
    }

    /**
     * 仮帰庫検索結果一覧に遷移します。
     * BS-2457 スコープ外の為表示しない。機能追加時に復活させる予定
     * @param {*} type
     * @param {*} rowId
     */
    // function showTemporaryReturnList(type, rowId)
    // {
    //     let tr      = (type == '1') ? $('#info_list1_table tr[data-row_id="' + rowId + '"]')
    //                 : null;
    //
    //     if (tr) {
    //         let updated_at          = tr.find('#updated_at').text() || '';      // 最終更新日時
    //         let holding_id          = $('#menu_holding_id').val() || '';        // 会社グループID
    //         let company_id          = $('#menu_company_id').val() || '';        // 会社ID
    //         let section_id          = tr.find('#section_id').text() || '';      // 営業所ID
    //         let record_id           = tr.find('#record_id').text() || '';       // 記録ID
    //         let driver_id           = tr.find('#driver_id').text() || '';       // 乗務員ID
    //         let driver_code         = tr.find('#driver_code').text() || '';     // 乗務員コード
    //         let vehicle_id          = tr.find('#vehicle_id').text() || '';      // 車両ID
    //         let vehicle_code        = tr.find('#vehicle_code').text() || '';    // 車両コード
    //
    //         /** クエリ文字列用データ生成 */
    //         let query_string        = $.param({
    //             division_type:      0,                                          // 0固定
    //             movement_flg:       null,                                       // null固定
    //             last_update_day:    updated_at,                                 // 最終更新日時
    //             holding_id:         holding_id,                                 // 会社グループID
    //             company_id:         company_id,                                 // 会社ID
    //             section_id:         section_id,                                 // 営業所ID
    //             record_id:          record_id,                                  // 記録ID
    //             driver_id:          driver_id,                                  // 乗務員ID
    //             driver_code:        driver_code,                                // 乗務員コード
    //             vehicle_id:         vehicle_id,                                 // 車両ID
    //             vehicle_code:       vehicle_code,                               // 車両コード
    //         });
    //
    //         /** 条件を付加して仮帰庫検索結果一覧に遷移する */
    //         window.location.href = _movement_map_settings_.url_temporary_return_list + '?' + query_string;
    //     }
    //     return false;
    // }

    /**
    * 車両・乗務員リストをクリアします。
    */
    function clearInfoListVehicles()
    {
        /** ヘッダを残して一覧をクリア(空データで一覧を再作成) */
        createInfoListVehicles(null);
    }

    /**
    * 地点リストをクリアします。
    */
    function clearInfoListDestinations()
    {
        /** ヘッダを残して一覧をクリア(空データで一覧を再作成) */
        createInfoListDestinations(null, _movement_map_settings_.messages, null);
    }

    /**
    * 免許証期限リストをクリアします。
    */
    function clearInfoListLicenseLimits()
    {
        /** ヘッダを残して一覧をクリア(空データで一覧を再作成) */
        createInfoListLicenseLimits(null, _movement_map_settings_.messages, null);
    }

    /**
     * 車両状態メッセージを取得します。
     * @param {*} vehicle_status
     * @param {*} messages
     */
    function getVehicleStatusMessage(vehicle_status, messages){

        let _vehicle_status = (vehicle_status || '').toString();
        let message = '';

        if (messages.vehicle_status_types.hasOwnProperty(_vehicle_status)){
            message = messages.vehicle_status_types[_vehicle_status];
        }

        return message;
    }

    /**
     * 認証ステータスに対応するイベントアイコンを取得します。
     * @param {*} license_certification_status
     */
    function getLicenseCertificationIcon(license_certification_status)
    {
        let license_certification_icon = false;
        let _license_certification_status = (license_certification_status || '').toString();

        if(LICENSE_CERTIFICATION_ICONS.hasOwnProperty(_license_certification_status)){
            license_certification_icon = LICENSE_CERTIFICATION_ICONS[_license_certification_status];
        }
        return license_certification_icon;
    }

    /**
     * 認証ステータスメッセージを取得します。
     * @param {*} license_certification_status
     * @param {*} messages
     */
    function getLicenseCertificationMessage(license_certification_status, messages){

        let _license_certification_status = (license_certification_status || '').toString();
        let message = '';
        if (messages.license_certification_status_types.hasOwnProperty(_license_certification_status)){
            message = messages.license_certification_status_types[_license_certification_status];
        } else {
            message = messages.license_certification_status_types['none'];
        }
        return message;
    }
    /**
     * 認証履歴表示
     */
    function getLicenseCertificationMessageByHistory(license_certification_status_history)
    {
        let rtnStr = "";
        if( license_certification_status_history && license_certification_status_history.length > 0 ){
            //ステータス判別
            let status_slice = function(status){
                let rtn = {
                    //ステータスコード
                    status_code:0,
                    //乗務員：識別子(1:乗務員、2:同乗者）
                    driver_identifier:null,
                    //乗務員ID
                    driver_id:null,
                };
                let strStatus = String(status);
                rtn.status_code = strStatus.slice(0,1);
                if (strStatus.length > 1) {
                    rtn.driver_identifier = strStatus.slice(1,2);
                    rtn.driver_id = strStatus.slice(2,12);
                }
                return rtn;
            }

            //表示する内容
            let show_status_text = function(statusObject){
                let str = "";
                switch (statusObject.status_code) {
                    //１：認証OK
                    case "1":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  + LICENSE_CERTIFICATION_NAMES[statusObject.status_code] + (statusObject.driver_id ? ":" + statusObject.driver_id : "");
                        break;
                    //４：認証OK（在職でない）
                    case "4":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code] + (statusObject.driver_id ? ":" + statusObject.driver_id : "");
                        break;
                    //５：認証NG（マスタ不備）
                    case "5":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code];
                        break;
                    //６：認証NG（読み取れなかった）
                    case "6":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code];
                        break;
                    //３：手入力OK
                    case "3":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code] + (statusObject.driver_id ? ":" + statusObject.driver_id : "");
                        break;
                    //７：手入力OK（在職でない）
                    case "7":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code] + (statusObject.driver_id ? ":" + statusObject.driver_id : "");
                        break;
                    //８：手入力NG（マスタ不備）
                    case "8":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code] + (statusObject.driver_id ? ":" + statusObject.driver_id : "");
                        break;
                    //９：手入力
                    case "9":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code] + (statusObject.driver_id ? ":" + statusObject.driver_id : "");
                        break;
                    //10：入力スキップ
                    case "0":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code];
                        break;
                    //2：認証NG
                    case "2":
                        str = ( (statusObject.driver_identifier === '2') ? '(同)' : "" )  +  LICENSE_CERTIFICATION_NAMES[statusObject.status_code];
                        break;

                    default:
                        break;
                }
                return str;
            }

            license_certification_status_history.forEach(function(ele,idx){
                let statusObject = status_slice(ele.status);
                if( rtnStr !== '' ){
                  rtnStr = rtnStr + "\n";
                }
                rtnStr = rtnStr + (idx+1) + "." +show_status_text(statusObject);
            });
        }
        return rtnStr;
    }

    /**
     * 実車／空車区分メッセージを取得します。
     * @param {*} luggage_status
     * @param {*} messages
     */
    function getLuggageStatusMessage(luggage_status, messages)
    {
        let _luggage_status = (luggage_status || '').toString();
        let message = _luggage_status;

        if (messages.luggage_status_types.hasOwnProperty(_luggage_status)){
            message = messages.luggage_status_types[_luggage_status];
        }

        return message;
    }

    /**
    * 免許証期限ステータスメッセージを取得します。
    * @param {*} license_limit_status
    * @param {*} messages
    */
    function getLicenseLimitStatusMessage(license_limit_status, messages)
    {
        let message = license_limit_status;

        /** 免許証有効期限ステータス(>0:有効期限までの残日数、0:期限日、<0:期限切れ(経過日数)、null:期限日未設定) */
        let key = '';
        if (license_limit_status != null && license_limit_status > 0) {
            /** 有効期限前 */
            key = 'days_remaining';
            if(messages.license_limit_status_types.hasOwnProperty(key)){
                message = license_limit_status.toString() + messages.license_limit_status_types[key];
            }

        } else {
            /** 上記以外 */
            if (license_limit_status != null) {
                if(license_limit_status === 0) {
                    /** 有効期限当日 */
                    key = 'due_date'
                } else if(license_limit_status < 0) {
                    /** 有効期限切れ */
                    key = 'license_expired'
                }
            } else{
                /** 期限日未設定 */
                key = 'none'
            }

            if(messages.license_limit_status_types.hasOwnProperty(key)){
                message = messages.license_limit_status_types[key];
            }
        }

        return message;
    }

    /**
     * 地点区分メッセージを取得します。
     * @param {*} destination_type
     * @param {*} messages
     */
    function getDestinationTypeMessage(destination_type, messages){

        let _destination_type = (destination_type || '').toString();
        let message = _destination_type;

        if(messages.destination_types.hasOwnProperty(_destination_type)){
            message = messages.destination_types[_destination_type];
        }
        return message;
    }

    /**
     * レイアウト切替状態を保存する
     */
    function setLayoutTypeData()
    {
        let layoutType = $('input[name="layout_type"]:checked');
        let settingKey = layoutType.data('setting_key');
        let action = layoutType.data('action');
        let params = {
            setting_key: settingKey,
            setting_value: layoutType.val() || ''
        };
        _ajax.post(action, params, function (response) {
            initialAll();
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }

    /**
     * 指定条件で車両・乗務員リストのフィルター設定を行います。
     */
    function setFilterInfoListVehicles()
    {
        /** 絞り込み条件の取得 */
        let search_inputs = ($('#search_input1').val() || '').trim().split(',');       // フリーワード(車両コード、車両番号、営業所名) ※カンマ区切りで複数指定可（OR条件）
        let vehicle_status = {
            1:  $('#vehicle_status_1').prop('checked'),     // 車両状態(1.走行中)
            2:  $('#vehicle_status_2').prop('checked'),     // 車両状態(2.荷積中)
            3:  $('#vehicle_status_3').prop('checked'),     // 車両状態(3.荷卸中)
            4:  $('#vehicle_status_4').prop('checked'),     // 車両状態(4.待機中)
            5:  $('#vehicle_status_5').prop('checked'),     // 車両状態(5.休憩中)
            6:  $('#vehicle_status_6').prop('checked'),     // 車両状態(6.フェリー)
            9:  $('#vehicle_status_9').prop('checked'),     // 車両状態(9.その他)
            11: $('#vehicle_status_11').prop('checked'),    // 車両状態(11.積置)
            12: $('#vehicle_status_12').prop('checked'),    // 車両状態(12.予冷)
            21: $('#vehicle_status_21').prop('checked'),    // 車両状態(21.温度異常)
            31: $('#vehicle_status_31').prop('checked'),    // 車両状態(31.遅延)
            88: $('#vehicle_status_88').prop('checked'),    // 車両状態(88.停車中)
            99: $('#vehicle_status_99').prop('checked'),    // 車両状態(99.運行終了)
        };
        let luggage_status = {
            1:  $('#luggage_status_1').prop('checked'),     // 実車／空車ステータス(1.実車)
            2:  $('#luggage_status_2').prop('checked'),     // 実車／空車ステータス(2.空車)
        };
        let vehicle_classification = ($('#vehicle_classification_id').val() || '').toString().trim();                  // 車両区分

        /** 条件に一致する対象IDの取得・リスト表示の更新 */
        let target_ids  = [];
        let list        = _movement_map_data_ ? _movement_map_data_['list_vehicles'] : null;
        if (list){
            $(list).each(function(i, item) {
                let is_target1  = false;    // 絞り込み判定用(フリーワード)
                let is_target2  = false;    // 絞り込み判定用(車両状態)
                let is_target3  = false;    // 絞り込み判定用(実車／空車ステータス)
                let is_target4  = false;    // 絞り込み判定用(車両区分)

                /** 絞り込み判定(フリーワード) */
                if (!search_inputs || search_inputs.length <= 0 || (search_inputs[0] || '').trim() === ''){
                    is_target1 = true;
                } else if (search_inputs && search_inputs.length > 0) {
                    search_inputs.forEach((search_input) => {
                        search_input = (search_input || '').trim();
                        if (search_input !== '') {
                            let vehicle_code = ('0000000000' + search_input).slice(-10);        // 車両コード
                            let vehicle_name = search_input;                                    // 車両番号
                            let section_name = search_input;                                    // 営業所名
                            let driver_code = ('0000000000' + search_input).slice(-10);         // 乗務員コード
                            let driver_name = search_input;                                     // 乗務員名

                            /** 車両コード */
                            if ((item.vehicle_code || '') === vehicle_code) {
                                is_target1 = true;
                            }
                            /** 車両番号 */
                            if ((item.vehicle_name || '').indexOf(vehicle_name) >= 0) {
                                is_target1 = true;
                            }
                            /** 営業所名 */
                            if ((item.section_name || '').indexOf(section_name) >= 0) {
                                is_target1 = true;
                            }
                            /** 乗務員コード */
                            if ((item.driver_code || '').indexOf(driver_code) >= 0) {
                                is_target1 = true;
                            }
                            /** 乗務員名 */
                            if ((item.driver_name || '').indexOf(driver_name) >= 0) {
                                is_target1 = true;
                            }
                        }
                    });
                }

                /** 絞り込み判定(車両状態、状態・警告) */
                if (((item.vehicle_status2 || '').toString() === '1' && vehicle_status[1]) ||
                    ((item.vehicle_status2 || '').toString() === '2' && vehicle_status[2]) ||
                    ((item.vehicle_status2 || '').toString() === '3' && vehicle_status[3]) ||
                    ((item.vehicle_status2 || '').toString() === '4' && vehicle_status[4]) ||
                    ((item.vehicle_status2 || '').toString() === '5' && vehicle_status[5]) ||
                    ((item.vehicle_status2 || '').toString() === '6' && vehicle_status[6]) ||
                    ((item.vehicle_status2 || '').toString() === '9' && vehicle_status[9]) ||
                    ((item.vehicle_status2 || '').toString() === '11' && vehicle_status[11]) ||
                    ((item.vehicle_status2 || '').toString() === '12' && vehicle_status[12]) ||
                    ((item.warning_status || '').toString() === '21' && vehicle_status[21]) ||
                    ((item.warning_status || '').toString() === '31' && vehicle_status[31]) ||
                    ((item.warning_status || '').toString() === '2111' && (vehicle_status[21] || vehicle_status[11])) ||
                    ((item.warning_status || '').toString() === '2112' && (vehicle_status[21] || vehicle_status[12])) ||
                    ((item.warning_status || '').toString() === '2131' && (vehicle_status[21] || vehicle_status[31])) ||
                    ((item.vehicle_status2 || '').toString() === '88' && vehicle_status[88]) ||
                    ((item.vehicle_status2 || '').toString() === '99' && vehicle_status[99])) {

                        is_target2 = true;
                }

                /** 絞り込み判定(実車／空車ステータス) */
                if (((item.luggage_status || '').toString() === '1' && luggage_status[1]) ||
                    ((item.luggage_status || '').toString() === '2' && luggage_status[2])) {

                        is_target3 = true;
                }

                /** 絞り込み判定(車両区分) */
                if (vehicle_classification === '') {
                    is_target4 = true;
                } else {
                    if ((item.vehicle_classification_id || '').toString() === vehicle_classification) {
                        is_target4 = true;
                    }
                }

                /** 全ての判定条件を満たす場合は表示対象 */
                let rowId   = item.record_id.toString();                                  // 記録ID
                let tr      = $('#info_list1_table tbody tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    if (is_target1 && is_target2 && is_target3 && is_target4) {
                        /** リストの対象行の表示化 */
                        tr.removeClass('d-none');

                        /** 表示対象として行IDを取得 */
                        target_ids.push(rowId);
                    } else {
                        /** リストの対象行の非表示化 */
                        tr.addClass('d-none');
                    }
                }
            });
        }

        /** 地図アイコンのフィルター設定 */
        _zMapMain.mapMovement.setFilterModeVehicles(target_ids);          // 車両アイコン
        _zMapMain.mapMovement.resetFilterModeDestinations();              // 地点アイコンはリセット
    }

    /**
     * 指定条件で地点リストのフィルター設定を行います。
     */
    function setFilterInfoListDestinations()
    {
        /** 絞り込み条件の取得 */
        let search_inputs = ($('#search_input2').val() || '').trim().split(',');
        let destination_types = {
            1: $('#destination_type_1').prop('checked'),   // 地点区分(1.積卸地)
            2: $('#destination_type_2').prop('checked'),   // 地点区分(2.ランドマーク)
            3: $('#destination_type_3').prop('checked'),   // 地点区分(3.自社拠点)
            4: $('#destination_type_4').prop('checked'),   // 地点区分(4.荷主)
            5: $('#destination_type_5').prop('checked'),   // 地点区分(5.給油所)
        };

        /** 条件に一致する対象IDの取得・リスト表示の更新 */
        let target_ids  = [];
        let list        = _movement_map_data_ ? _movement_map_data_['list_destinations'] : null;
        if (list){
            $(list).each(function(i, item){

                let is_target1  = false;    // 絞り込み判定用(フリーワード)
                let is_target2  = false;    // 絞り込み判定用(地点区分)

                /** 絞り込み判定(フリーワード) */
                if (!search_inputs || search_inputs.length <= 0 || (search_inputs[0] || '').trim() === ''){
                    is_target1 = true;
                } else if (search_inputs && search_inputs.length > 0) {
                    search_inputs.forEach((search_input) => {
                        search_input = (search_input || '').trim();
                        if (search_input !== '') {
                            let destination_code    = ('00000000' + search_input).slice(-8);       // 地点コード
                            let destination_name    = search_input;                                // 地点名
                            let zipcode             = search_input;                                // 郵便番号
                            let address             = search_input;                                // 住所
                            let phone_number        = search_input;                                // 電話番号

                            /** 地点コード */
                            if ((item.code || '') === destination_code) {
                                is_target1 = true;
                            }
                            /** 地点名 */
                            if ((item.name || '').indexOf(destination_name) >= 0) {
                                is_target1 = true;
                            }
                            /** 郵便番号 */
                            if ((item.zipcode || '').replace(/\-/g, '').indexOf(zipcode.replace(/\-/g, '')) >= 0) {
                                is_target1 = true;
                            }
                            /** 住所 */
                            if ((item.address || '').indexOf(address) >= 0) {
                                is_target1 = true;
                            }
                            /** 電話番号 */
                            if ((item.phone_number || '').replace(/\-/g, '').replace(/\(/g, '').replace(/\)/g, '').indexOf(phone_number.replace(/\-/g, '').replace(/\(/g, '').replace(/\)/g, '')) >= 0) {
                                is_target1 = true;
                            }
                        }
                    });
                }

                /** 絞り込み判定(地点区分) */
                if (((item.destination_type || '').toString() === '1' && destination_types[1]) ||
                    ((item.destination_type || '').toString() === '2' && destination_types[2]) ||
                    ((item.destination_type || '').toString() === '3' && destination_types[3]) ||
                    ((item.destination_type || '').toString() === '4' && destination_types[4]) ||
                    ((item.destination_type || '').toString() === '5' && destination_types[5])) {
                        is_target2 = true;
                }

                /** 全ての判定条件を満たす場合は表示対象 */
                let rowId   = item.id.toString();                                           // 地点ID（行先ID）
                let tr      = $('#info_list2_table tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    if (is_target1 && is_target2) {
                        /** リストの対象行の表示化 */
                        tr.removeClass('d-none');

                        /** 表示対象として行IDを取得 */
                        target_ids.push(rowId);
                    } else {
                        /** リストの対象行の非表示化 */
                        tr.addClass('d-none');
                    }
                }
            });
        }

        /** 地図アイコンのフィルター設定 */
        _zMapMain.mapMovement.setFilterModeDestinations(target_ids);                // 地点アイコン
        _zMapMain.mapMovement.resetFilterModeVehicles();                            // 車両アイコンはリセット
    }

    /**
     * 指定条件で免許証期限リストのフィルター設定を行います。
     */
    function setFilterInfoListLicenseLimits()
    {
        /** 絞り込み条件の取得 */
        let search_inputs = ($('#search_input3').val() || '').trim().split(',');    // フリーワード(乗務員コード、乗務名、営業所名) ※カンマ区切りで複数指定可（OR条件）

        /** 条件に一致する対象IDの取得・リスト表示の更新 */
        let target_ids  = [];
        let list        = _movement_map_data_ ? _movement_map_data_['list_license_limits'] : null;
        if (list){
            $(list).each(function(i, item){

                let is_target1  = false;    // 絞り込み判定用(フリーワード)

                /** 絞り込み判定(フリーワード) */
                if (!search_inputs || search_inputs.length <= 0 || (search_inputs[0] || '').trim() === ''){
                    is_target1 = true;
                } else if (search_inputs && search_inputs.length > 0) {
                    search_inputs.forEach((search_input) => {
                        search_input = (search_input || '').trim();
                        if (search_input !== '') {
                            let driver_code     = ('0000000000' + search_input).slice(-10);;       // 乗務員コード
                            let driver_name     = search_input;                                    // 乗務員名
                            let section_name    = search_input;                                    // 営業所名

                            /** 乗務員コード */
                            if ((item.driver_code || '') === driver_code) {
                                is_target1 = true;
                            }
                            /** 乗務員名 */
                            if ((item.driver_name || '').indexOf(driver_name) >= 0) {
                                is_target1 = true;
                            }
                            /** 営業所名 */
                            if ((item.section_name || '').indexOf(section_name) >= 0) {
                                is_target1 = true;
                            }
                        }
                    });
                }

                /** 全ての判定条件を満たす場合は表示対象 */
                let rowId   = item.record_id.toString();                                    // 記録ID
                let tr      = $('#info_list3_table tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    if (is_target1) {
                        /** リストの対象行の表示化 */
                        tr.removeClass('d-none');

                        /** 表示対象として行IDを取得 */
                        target_ids.push(rowId);
                    } else {
                        /** リストの対象行の非表示化 */
                        tr.addClass('d-none');
                    }
                }
            });
        }

        /** 地図アイコンのフィルター設定 */
        _zMapMain.mapMovement.setFilterModeVehicles(target_ids);          // 車両アイコン
        _zMapMain.mapMovement.resetFilterModeDestinations();              // 地点アイコンはリセット
    }


    /**
     * 車両・乗務員リストのフィルター設定を解除します。
     */
    function resetFilterInfoListVehicles()
    {
        /** リストのフィルター設定を一括解除 */
        let list = _movement_map_data_ ? _movement_map_data_['list_vehicles'] : null;
        if (list){
            $(list).each(function(i, item){
                let rowId   = item.record_id.toString();                                    // 記録ID
                let tr      = $('#info_list1_table tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    tr.removeClass('d-none');
                }
            });
        }
        /** 地図アイコンのフィルター設定を一括解除 */
        _zMapMain.mapMovement.resetFilterModeVehicles();          // 車両アイコン
        _zMapMain.mapMovement.resetFilterModeDestinations();      // 地点アイコン

        _is_filter_mode_1_ = false;
    }

    /**
     * 地点リストのフィルター設定を解除します。
     */
    function resetFilterInfoListDestinations()
    {
        /** リストのフィルター設定を一括解除 */
        let list = _movement_map_data_ ? _movement_map_data_['list_destinations'] : null;
        if (list){
            $(list).each(function(i, item){
                let rowId   = item.id.toString();                                           // 地点ID（行先ID）
                let tr      = $('#info_list2_table tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    tr.removeClass('d-none');
                }
            });
        }
        /** 地図アイコンのフィルター設定を一括解除 */
        _zMapMain.mapMovement.resetFilterModeVehicles();          // 車両アイコン
        _zMapMain.mapMovement.resetFilterModeDestinations();      // 地点アイコン

        _is_filter_mode_2_ = false;
    }

    /**
     * 免許証期限リストのフィルター設定を解除します。
     */
    function resetFilterInfoListLicenseLimits()
    {
        /** リストのフィルター設定を一括解除 */
        let list = _movement_map_data_ ? _movement_map_data_['list_license_limits'] : null;
        if (list){
            $(list).each(function(i, item){
                let rowId   = item.record_id.toString();                                    // 記録ID
                let tr      = $('#info_list3_table tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    tr.removeClass('d-none');
                }
            });
        }
        /** 地図アイコンのフィルター設定を一括解除 */
        _zMapMain.mapMovement.resetFilterModeVehicles();          // 車両アイコン
        _zMapMain.mapMovement.resetFilterModeDestinations();      // 地点アイコン

        _is_filter_mode_3_ = false;
    }

    /**
     * 各リストのフィルター設定を一括解除します。
     */
    function resetFilterInfoList()
    {
        /** 車両・乗務員リストのフィルター設定を解除 */
        resetFilterInfoListVehicles();
        /** 地点リストのフィルター設定を解除 */
        resetFilterInfoListDestinations();
        /** 免許証期限リストのフィルター設定を解除 */
        resetFilterInfoListLicenseLimits();

    }

    /**
    * 車両・乗務員リストの絞り込み条件をクリアします。
    */
    function clearInputFilterVehicles()
    {
        /** 絞り込み条件欄のクリア */
        $('#search_input1').val(''); // フリーワード(車両コード、車両番号、営業所名)

        $('#vehicle_status_1').prop('checked', true);              // 車両状態(1.走行中)
        $('#vehicle_status_2').prop('checked', true);              // 車両状態(2.荷積中)
        $('#vehicle_status_3').prop('checked', true);              // 車両状態(3.荷卸中)
        $('#vehicle_status_4').prop('checked', true);              // 車両状態(4.待機中)
        $('#vehicle_status_5').prop('checked', true);              // 車両状態(5.休憩中)
        $('#vehicle_status_9').prop('checked', true);              // 車両状態(9.その他)
        $('#vehicle_status_11').prop('checked', true);             // 車両状態(11.積置)
        $('#vehicle_status_12').prop('checked', true);             // 車両状態(12.予冷)
        $('#vehicle_status_21').prop('checked', true);             // 車両状態(21.温度異常)
        $('#vehicle_status_31').prop('checked', true);             // 車両状態(31.遅延)
        $('#vehicle_status_99').prop('checked', true);             // 車両状態(99.運行終了)

        $('#luggage_status_1').prop('checked', true);              // 実車／空車ステータス(1.実車)
        $('#luggage_status_2').prop('checked', true);              // 実車／空車ステータス(2.空車)

        // 車両区分
        $('#vehicle_classification').empty().append(new Option('---', '', true, true)).trigger('change');
    }

    /**
    * 地点リストの絞り込み条件をクリアします。
    */
    function clearInputFilterDestinations()
    {
        /** 絞り込み条件欄のクリア */
        $('#search_input2').val(''); // フリーワード(地点コード、地点名、住所、電話番号)

        $('#destination_type_1').prop('checked', true);            // 地点区分(1.積地)
        $('#destination_type_2').prop('checked', true);            // 地点区分(2.卸地)
        $('#destination_type_3').prop('checked', true);            // 地点区分(3.自社拠点)
        $('#destination_type_4').prop('checked', true);            // 地点区分(4.荷主)
        $('#destination_type_5').prop('checked', true);            // 地点区分(5.給油所)

    }

    /**
    * 免許証期限リストの絞り込み条件をクリアします。
    */
    function clearInputFilterLicenseLimits()
    {
        /** 絞り込み条件欄のクリア */
        $('#search_input3').val(''); // フリーワード(乗務員コード、乗務名、営業所名)
    }

    /**
     * 絞り込み条件欄を一括クリア初期化します。
     */
    function clearInputFilter()
    {
        /** 車両・乗務員リストの絞り込み条件欄のクリア */
        clearInputFilterVehicles();
        /** 地点リストの絞り込み条件欄のクリア */
        clearInputFilterDestinations();
        /** 免許証期限リストの絞り込み条件欄のクリア */
        clearInputFilterLicenseLimits();

    }

    /**
     * 検索結果リストの列ヘッダ押下時のイベント処理を行います。
     * @param {*} type
     * @param {*} column_id
     */
    function onClickThInfoList(type, column_id)
    {
        let tr = $('#info_list' + type + '_table thead tr');
        if (tr) {
            let sort_column = column_id.replace('#th_', '');
            let sort_type = (tr.find(column_id).hasClass('sorting') || tr.find(column_id).hasClass('sorting_desc') ? 1 : 2);

            // init
            _zMapMain.mapMovement.closeInfoboxVehicleAll();
            _zMapMain.mapMovement.closeInfoboxDestinationAll();
            _zMapSub.mapMovementSub?.closeInfoboxVehicleAll();
            _zMapSub.mapMovementSub?.closeInfoboxDestinationAll();

            /** 並べ替えデータ取得&リストを再作成 */
            switch (type.toString()) {
                case '1':
                    _movement_map_data_['list_vehicles'] = getSortDataVehicles(_movement_map_data_['list_vehicles'], sort_column, sort_type);
                    createInfoListVehicles(_movement_map_data_['list_vehicles'], _movement_map_settings_.messages, _movement_settings_);
                    /** 指定条件でイベントリストのフィルター設定 */
                    if(_is_filter_mode_1_) {
                        setFilterInfoListVehicles();
                    }
                    break;
                case '2':
                    _movement_map_data_['list_destinations'] = getSortDataDestinations(_movement_map_data_['list_destinations'], sort_column, sort_type);
                    createInfoListDestinations(_movement_map_data_['list_destinations'], _movement_map_settings_.messages, _movement_settings_);
                    /** 指定条件でイベントリストのフィルター設定 */
                    if(_is_filter_mode_2_) {
                        setFilterInfoListDestinations();
                    }
                    break;
                case '3':
                    /** 並べ替えデータ取得 */
                    _movement_map_data_['list_license_limits'] = getSortDataLicenseLimits(_movement_map_data_['list_license_limits'], sort_column, sort_type);
                    createInfoListLicenseLimits(_movement_map_data_['list_license_limits'], _movement_map_settings_.messages, _movement_settings_);
                    /** 指定条件でイベントリストのフィルター設定 */
                    if(_is_filter_mode_3_) {
                        setFilterInfoListLicenseLimits();
                    }
                    break;
            }
            /** 並べ替えアイコンを設定 */
            setSortIconInfoList(sort_column, sort_type, 'info_list' + type.toString());
        }
        return false;
    }

    /**
     * 検索結果リストの現在有効になっている並べ替え条件を取得します。
     */
    function getSortParamInfoList(id)
    {
        let listSettings = _movement_map_settings_.messages[id];
        let sort_columns = {};

        // ソート対象カラム取得
        let i = 0;
        $.each(listSettings, function(key, value) {
            if (value.hasOwnProperty('sorting') && value.sorting === true) {
                i++;
                sort_columns[i] = key;
            }
        });
        // 現ソート中カラム取得
        // init
        let sort_param = {
            sort_column:    sort_columns[1],
            sort_type:      1,
        };
        let tr = $('#' + id + '_table tr');
        if (tr) {
            $.each(sort_columns, function(key, value) {
                if (tr.find('#th_' + value).hasClass('sorting_asc')) {
                    sort_param = {
                        sort_column: value,
                        sort_type: 1,
                    };
                    return false;
                } else if (tr.find('#th_' + value).hasClass('sorting_desc')) {
                    sort_param = {
                        sort_column: value,
                        sort_type: 2,
                    };
                    return false;
                } else {

                }
            });
        }
        return sort_param;
    }

    /**
     * 検索結果リストの並べ替えアイコンを設定します。
     * @param {*} sort_column
     * @param {*} sort_type
     * @param {*} id
     */
    function setSortIconInfoList(sort_column, sort_type, id)
    {
        let listSettings = _movement_map_settings_.messages[id];
        let tr = $('#' + id + '_table thead tr');
        if (tr) {
            // init
            tr.find('th').not('.sorting_disabled').removeClass('sorting_asc').removeClass('sorting_desc').addClass('sorting');
            // set
            $.each(listSettings, function(key, value) {
                if (value.hasOwnProperty('sorting') && value.sorting === true && key === sort_column) {
                    tr.find('#th_' + key).removeClass('sorting').addClass((sort_type === 1 ? 'sorting_asc' : 'sorting_desc'));
                    return false;
                }
            });
        }
        return false;
    }

    /**
     * 検索結果リスト(車両)の並べ替えデータを取得します。
     * @param {*} list
     * @param {*} sort_column
     * @param {*} sort_type
     */
    function getSortDataVehicles(list, sort_column, sort_type)
    {
        let data    = $.extend(true, {}, list);
        data = Object.keys(data).map(key => data[key]);

        sort_column = (sort_column || 'vehicle_code');
        sort_type   = (sort_type || 1);

        switch (sort_column) {
            case 'vehicle_name':
                // 2.車両番号
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 車両番号 */
                        if (naturalStringCompare((item1.vehicle_name || ''), (item2.vehicle_name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.vehicle_name || ''), (item2.vehicle_name || '')) > 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 車両番号 */
                        if (naturalStringCompare((item1.vehicle_name || ''), (item2.vehicle_name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.vehicle_name || ''), (item2.vehicle_name || '')) < 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'warning_status':
                // 3.状態・警告
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 状態・警告 */
                        if (naturalStringCompare((item1.warning_status || ''), (item2.warning_status || '')) < 0) return -1;
                        if (naturalStringCompare((item1.warning_status || ''), (item2.warning_status || '')) > 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 状態・警告 */
                        if (naturalStringCompare((item1.warning_status || ''), (item2.warning_status || '')) > 0) return -1;
                        if (naturalStringCompare((item1.warning_status || ''), (item2.warning_status || '')) < 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'vehicle_status':
                // 4.車両状態
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 車両状態 */
                        if (naturalStringCompare((item1.vehicle_status2 || ''), (item2.vehicle_status2 || '')) < 0) return -1;
                        if (naturalStringCompare((item1.vehicle_status2 || ''), (item2.vehicle_status2 || '')) > 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 車両状態 */
                        if (naturalStringCompare((item1.vehicle_status2 || ''), (item2.vehicle_status2 || '')) > 0) return -1;
                        if (naturalStringCompare((item1.vehicle_status2 || ''), (item2.vehicle_status2 || '')) < 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'section_name':
                // 6.営業所名
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        /** 営業所名 */
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) > 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        /** 営業所名 */
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) < 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'temporary_return':
                // 9.仮帰庫手続き
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 仮帰庫手続き(運行終了か否か) */
                        if(((item1.vehicle_status || '').toString() !== '99' ? 0 : 1) < ((item2.vehicle_status || '').toString() !== '99' ? 0 : 1)) return -1;
                        if(((item1.vehicle_status || '').toString() !== '99' ? 0 : 1) > ((item2.vehicle_status || '').toString() !== '99' ? 0 : 1)) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 仮帰庫手続き(運行終了か否か) */
                        if(((item1.vehicle_status || '').toString() !== '99' ? 0 : 1) > ((item2.vehicle_status || '').toString() !== '99' ? 0 : 1)) return -1;
                        if(((item1.vehicle_status || '').toString() !== '99' ? 0 : 1) < ((item2.vehicle_status || '').toString() !== '99' ? 0 : 1)) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            default:
                // 共通
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** sort_column */
                        if (naturalStringCompare((item1[sort_column] || ''), (item2[sort_column] || '')) < 0) return -1;
                        if (naturalStringCompare((item1[sort_column] || ''), (item2[sort_column] || '')) > 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** sort_column */
                        if (naturalStringCompare((item1[sort_column] || ''), (item2[sort_column] || '')) > 0) return -1;
                        if (naturalStringCompare((item1[sort_column] || ''), (item2[sort_column] || '')) < 0) return 1;
                        /** 車両コード */
                        if((item1.vehicle_code || '').toString() > (item2.vehicle_code || '').toString()) return -1;
                        if((item1.vehicle_code || '').toString() < (item2.vehicle_code || '').toString()) return 1;
                        /** 車両ID */
                        if((item1.vehicle_id || '').toString() > (item2.vehicle_id || '').toString()) return -1;
                        if((item1.vehicle_id || '').toString() < (item2.vehicle_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;
        }
        return data;
    }

    /**
     * 検索結果リスト(地点)の並べ替えデータを取得します。
     * @param {*} list
     * @param {*} sort_column
     * @param {*} sort_type
     */
    function getSortDataDestinations(list, sort_column, sort_type)
    {
        let data    = $.extend(true, {}, list);
        data = Object.keys(data).map(key => data[key]);

        sort_column = (sort_column || 'destination_code');
        sort_type   = (sort_type || 1);

        switch(sort_column) {
            case 'destination_code':
                // 1.地点コード
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 地点コード */
                        if((item1.code || '').toString() < (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() > (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 地点コード */
                        if((item1.code || '').toString() > (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() < (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'destination_name':
                // 2.地点名
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 地点名 */
                        if (naturalStringCompare((item1.name || ''), (item2.name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.name || ''), (item2.name || '')) > 0) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() < (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() > (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 地点名 */
                        if (naturalStringCompare((item1.name || ''), (item2.name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.name || ''), (item2.name || '')) < 0) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() > (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() < (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'address':
                // 3.住所
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 郵便番号 */
                        if(toZipcodeFormat(item1.zipcode || '') < toZipcodeFormat(item2.zipcode || '')) return -1;
                        if(toZipcodeFormat(item1.zipcode || '') > toZipcodeFormat(item2.zipcode || '')) return 1;
                        /** 住所 */
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) < 0) return -1;
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) > 0) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() < (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() > (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 郵便番号 */
                        if(toZipcodeFormat(item1.zipcode || '') > toZipcodeFormat(item2.zipcode || '')) return -1;
                        if(toZipcodeFormat(item1.zipcode || '') < toZipcodeFormat(item2.zipcode || '')) return 1;
                        /** 住所 */
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) > 0) return -1;
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) < 0) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() > (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() < (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'phone_number':
                // 4.電話番号
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 電話番号 */
                        if (naturalStringCompare((item1.phone_number || ''), (item2.phone_number || '')) < 0) return -1;
                        if (naturalStringCompare((item1.phone_number || ''), (item2.phone_number || '')) > 0) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() < (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() > (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 電話番号 */
                        if (naturalStringCompare((item1.phone_number || ''), (item2.phone_number || '')) > 0) return -1;
                        if (naturalStringCompare((item1.phone_number || ''), (item2.phone_number || '')) < 0) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() > (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() < (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'destination_type':
                // 5.地点区分
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 地点区分 */
                        if((item1.destination_type || '').toString() < (item2.destination_type || '').toString()) return -1;
                        if((item1.destination_type || '').toString() > (item2.destination_type || '').toString()) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() < (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() > (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 地点区分 */
                        if((item1.destination_type || '').toString() > (item2.destination_type || '').toString()) return -1;
                        if((item1.destination_type || '').toString() < (item2.destination_type || '').toString()) return 1;
                        /** 地点コード */
                        if((item1.code || '').toString() > (item2.code || '').toString()) return -1;
                        if((item1.code || '').toString() < (item2.code || '').toString()) return 1;
                        /** 地点ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;
        }
        return data;
    }

    /**
     * 検索結果リスト(免許証期限)の並べ替えデータを取得します。
     * @param {*} list
     * @param {*} sort_column
     * @param {*} sort_type
     */
    function getSortDataLicenseLimits(list, sort_column, sort_type)
    {
        let data = $.extend(true, {}, list);
        data = Object.keys(data).map(key => data[key]);

        sort_column = (sort_column || 'driver_code');
        sort_type   = (sort_type || 1);

        switch(sort_column) {
            case 'driver_code':
                // 1.乗務員コード
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'driver_name':
                // 2.乗務員名
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 乗務員名 */
                        if (naturalStringCompare((item1.driver_name || ''), (item2.driver_name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.driver_name || ''), (item2.driver_name || '')) > 0) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 乗務員名 */
                        if (naturalStringCompare((item1.driver_name || ''), (item2.driver_name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.driver_name || ''), (item2.driver_name || '')) < 0) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'license_grant':
                // 3.交付日
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 交付日 */
                        if(moment(item1.license_grant).format('YYYY/MM/DD') < moment(item2.license_grant).format('YYYY/MM/DD')) return -1;
                        if(moment(item1.license_grant).format('YYYY/MM/DD') > moment(item2.license_grant).format('YYYY/MM/DD')) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 交付日 */
                        if(moment(item1.license_grant).format('YYYY/MM/DD') > moment(item2.license_grant).format('YYYY/MM/DD')) return -1;
                        if(moment(item1.license_grant).format('YYYY/MM/DD') < moment(item2.license_grant).format('YYYY/MM/DD')) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'license_limit':
                // 4.有効期限
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 有効期限 */
                        if(moment(item1.license_limit).format('YYYY/MM/DD') < moment(item2.license_limit).format('YYYY/MM/DD')) return -1;
                        if(moment(item1.license_limit).format('YYYY/MM/DD') > moment(item2.license_limit).format('YYYY/MM/DD')) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 有効期限 */
                        if(moment(item1.license_limit).format('YYYY/MM/DD') > moment(item2.license_limit).format('YYYY/MM/DD')) return -1;
                        if(moment(item1.license_limit).format('YYYY/MM/DD') < moment(item2.license_limit).format('YYYY/MM/DD')) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'license_limit_status':
                // 5.期限状態
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 期限状態 */
                        if((item1.license_limit_status || '').toString() < (item2.license_limit_status || '').toString()) return -1;
                        if((item1.license_limit_status || '').toString() > (item2.license_limit_status || '').toString()) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 期限状態 */
                        if((item1.license_limit_status || '').toString() > (item2.license_limit_status || '').toString()) return -1;
                        if((item1.license_limit_status || '').toString() < (item2.license_limit_status || '').toString()) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'section_name':
                // 6.営業所名
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        /** 営業所名 */
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) > 0) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        /** 営業所名 */
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.section_name || ''), (item2.section_name || '')) < 0) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'license_certification':
                // 7.免許証認証
                if (sort_type === 1) {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 免許証認証ステータス */
                        if((item1.license_certification_status || '').toString() < (item2.license_certification_status || '').toString()) return -1;
                        if((item1.license_certification_status || '').toString() > (item2.license_certification_status || '').toString()) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 免許証認証ステータス */
                        if((item1.license_certification_status || '').toString() > (item2.license_certification_status || '').toString()) return -1;
                        if((item1.license_certification_status || '').toString() < (item2.license_certification_status || '').toString()) return 1;
                        /** 乗務員コード */
                        if((item1.driver_code || '').toString() > (item2.driver_code || '').toString()) return -1;
                        if((item1.driver_code || '').toString() < (item2.driver_code || '').toString()) return 1;
                        /** 乗務員ID */
                        if((item1.driver_id || '').toString() > (item2.driver_id || '').toString()) return -1;
                        if((item1.driver_id || '').toString() < (item2.driver_id || '').toString()) return 1;
                        /** 営業所ID */
                        if((item1.section_id || '').toString() > (item2.section_id || '').toString()) return -1;
                        if((item1.section_id || '').toString() < (item2.section_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;
        }
        return data;
    }
}


/**
 * 地図上の地点アイコンの吹き出しのグラフボタン押下
 */
window.showTempGraph = function(elm, e)
{
    // バブリング停止
    e.preventDefault();
    e.stopPropagation();

    $(elm).data('action', _movement_map_settings_.url_temperature);
    _modal.create_with_data(elm, 'temperature_modal', {
        'holding_id': $(elm).data('holding_id'),
        'company_id': $(elm).data('company_id'),
        'section_id': $(elm).data('section_id'),
        'record_id': $(elm).data('record_id'),
    }, false, null);

    return false;
}

/**
 * 動態表示で設定したイベントクリア
 */
window.clearMovementMapEvent = function(zMapMain)
{
    if (_movement_map_data_) {
        let is_tracking_mode    = zMapMain.mapMovement.isTrackingMode(); // メイン地図が追尾モードかどうか？（１画面レイアウト時のみ）
        let is_fixed            = $('#map_position_is_fixed').val() || '';      // 地図デフォルト位置固定(0:無効、1:有効)
        if (is_fixed === '1' && !is_tracking_mode) {
            /** 現在の地図の中心位置・倍率を取得 */
            let params = zMapMain.mapMovement.getCurrMapPosition();
            if (params) {
                /** 地図の中心位置・倍率設定を設定する */
                $('#map_position_is_fixed').val(1);             // 地図デフォルト位置固定(0:無効、1:有効)
                $('#map_position_lat').val(params.lat);         // 地図デフォルト中心位置(緯度)
                $('#map_position_lon').val(params.lon);         // 地図デフォルト中心位置(経度)
                $('#map_position_zoom').val(params.zoom);       // 地図デフォルト倍率

                /** 作業状態の設定を更新 */
                setDefaultMapPositionData();
            }
        }
    }

    if (_refresh_timer_) {
        clearInterval(_refresh_timer_);
        _refresh_timer_ = false;
    }
}


